import RioCountedInput from '@rio-cloud/rio-uikit/CountedInput';
import { type Control, Controller, type FieldPath, type FieldValues } from 'react-hook-form';

import FormGroup from '@/components/ui/FormGroup';

export type CountedInputProps<T extends FieldValues> = {
    control: Control<T>;
    name: FieldPath<T>;
    label?: string;
    id?: string;
    required?: boolean;
    error?: string;
    className?: string;
    placeholder?: string;
    minLength?: number;
    maxLength: number;
    disabled?: boolean;
};

const CountedInput = <T extends FieldValues>({
    control,
    name,
    label,
    id = `${label}-input`,
    required,
    error,
    className,
    placeholder,
    minLength,
    maxLength,
    disabled,
}: CountedInputProps<T>) => (
    <Controller
        control={control}
        name={name}
        render={({ field: { onChange, onBlur, value, name: fieldName } }) => {
            const input = (
                <RioCountedInput
                    id={id}
                    name={fieldName}
                    value={(value as string) ?? ''}
                    onChange={newValue => onChange(newValue)}
                    onBlur={onBlur}
                    placeholder={placeholder}
                    minLength={minLength}
                    maxLength={maxLength}
                    hasError={!!error}
                    disabled={disabled}
                    showValidationState={false}
                    className='margin-bottom-0'
                />
            );

            const wrapperClassName = `margin-bottom-0 ${className ?? ''}`.trim();

            if (!label) {
                return <div className={wrapperClassName}>{input}</div>;
            }

            return (
                <FormGroup label={label} required={required} error={error} className={wrapperClassName} htmlFor={id}>
                    {input}
                </FormGroup>
            );
        }}
    />
);

export default CountedInput;
